import CrudPage from '../../components/CrudPage'
import { productosCrud } from '../../api/entities'

// ABM Productos — SOLO LECTURA (listado). Lectura: GET /productos?view=BaseList&search=or(nombre|codigo).
//
// MOTIVO (validado en vivo contra el MT, 2026-06-25, admin_fvv):
//   POST /productos {nombre} -> HTTP 400 con SEIS @NotNull simultáneos:
//     tiposImpuesto, claseProducto, lineaProducto, proveedorPrincipal, unidadMedidaBase, estado.
//   Varios son catálogos pesados: lineaProducto es un árbol jerárquico multi-nivel,
//   proveedorPrincipal requiere elegir un proveedor, y la entidad además usa criterioControl,
//   unidadesMedida[] y codigoBarrasPrincipal. Un alta correcta excede un diálogo ABM genérico
//   (necesitaría 6+ selects, uno arbóreo y otro con lookup de proveedor) y rompería si se intenta.
//   => Se deja la página como solo lectura (readOnly + canCreate=false). El alta/edición de
//   productos se hace por el módulo de Qualita ERP, no por este front ágil.
export default function ProductosPage() {
  return (
    <CrudPage
      title="Productos"
      api={productosCrud}
      readOnly
      canCreate={false}
      canEdit={false}
      canDelete={false}
      searchPlaceholder="Buscar por nombre o código (mín. 3 letras)"
      columns={[
        { key: 'codigo', label: 'Código' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'tiposImpuesto.0.descripcion', label: 'IVA' },
        { key: 'lineaProducto.codigoNombre', label: 'Línea' },
        { key: 'unidadMedidaBase.descripcion', label: 'Unidad' },
      ]}
    />
  )
}
